import { IconUsers } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { Text } from "@fragments";

import "./styles.scss";

export default function GroupHeader({ groupInfo }) {
    const { t } = useTranslation("community");

    return (
        <div className="group-header">
            <div className="group-header__banner-wrap">
                {groupInfo.banner ? (
                    <img
                        src={groupInfo.banner}
                        className="group-header__banner"
                        alt=""
                    />
                ) : (
                    <div className="group-header__banner group-header__banner--empty" />
                )}
            </div>

            <div className="group-header__info">
                <Text.h3 contrast={9}>{groupInfo.name}</Text.h3>
                <div className="group-header__meta">
                    <Text.span contrast={4} left={<IconUsers size={13} />}>
                        {t("group.posts", { count: groupInfo.posts_total })}
                    </Text.span>
                </div>
            </div>
        </div>
    );
}
